import { Button, FormControl, MenuItem, Select, Snackbar, Tooltip } from "@material-ui/core";
import { PlayArrow, Replay, Stop } from "@material-ui/icons";
import BlockIcon from "@material-ui/icons/Block";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import EmojiEventsIcon from "@material-ui/icons/EmojiEvents";
import StarBorderIcon from "@material-ui/icons/StarBorder";
import IpadIcon from "@material-ui/icons/TabletMacOutlined";
import VideocamOutlined from "@material-ui/icons/VideocamOutlined";
import VideocamOffOutlined from "@material-ui/icons/VideocamOffOutlined";
import MuiAlert from "@material-ui/lab/Alert";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import { FRONT_URL } from "../../../../api";
import {
  deleteGame,
  getGames,
  resetGameStats,
  setDefaultGame,
  updateGame,
} from "../../../../api/game";
import { alertError, alertSuccess } from "../../../../utils/logger";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import Table, { buttonsStyle } from "../../../components/tables/table";

function getData(games) {
  let data = [];
  for (let i = 0; i < games.length; ++i) {
    const elem = {};
    elem.name = games[i].fullName;
    elem.createdAt = games[i].createdAt;
    elem.default = games[i].default;
    elem.data = games[i];
    elem.id = games[i]._id;
    data = data.concat(elem);
  }
  return data;
}

export default function GamesPage() {
  const [data, setData] = useState([]);
  const [gameId, setGameId] = useState(null);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(null);
  const [refresh, setRefresh] = useState(false);
  const [copiedLink, setCopiedLink] = useState(false);
  const history = useHistory();

  const getCurrentStatus = (game) =>
    game?.status || (game?.active ? "play" : "registration");
  const getStatusLabel = (status) =>
    ({ blocked: "Bloqueado", registration: "Permitir registro", play: "Permitir juego" })[status] || status;
  const StatusIcon = ({ status }) =>
    status === "blocked" ? <BlockIcon fontSize="small" /> : status === "play" ? <PlayArrow fontSize="small" /> : <Stop fontSize="small" />;

  function buttonFormatter(cell) {
    const game = cell;
    const currentStatus = getCurrentStatus(game);

    const handleStatusChange = (e) => {
      e.stopPropagation();
      const newStatus = e.target.value;
      if (newStatus === currentStatus) return;
      updateGame(game._id, { ...game, status: newStatus })
        .then((res) => {
          if (res.status === 200) {
            alertSuccess({ title: "Actualizado", customMessage: `Estado: ${getStatusLabel(newStatus)}.` });
            setRefresh(true);
          }
        })
        .catch((err) => {
          alertError({ error: err, customMessage: "No se pudo actualizar el juego." });
        });
    };

    return (
      <>
        {!cell.default && (
          <Tooltip title="Set Default">
            <Button
              style={buttonsStyle}
              size="small"
              onClick={() => {
                setGameId(cell._id);
                setOpenConfirmDialog(1);
              }}
            >
              <StarBorderIcon />
            </Button>
          </Tooltip>
        )}
        <Tooltip title="Ranking">
          <Button
            style={buttonsStyle}
            size="small"
            onClick={() => history.push("/ranking-game/" + cell._id)}
          >
            <EmojiEventsIcon />
          </Button>
        </Tooltip>
        <Tooltip title={getStatusLabel(currentStatus)}>
          <FormControl size="small" variant="outlined" className="game-status-select" style={{ width: 56, minWidth: 56 }} onClick={(e) => e.stopPropagation()}>
            <Select
              value={currentStatus}
              onChange={handleStatusChange}
              renderValue={(value) => <span style={{ marginRight: 4 }}><StatusIcon status={value} /></span>}
              displayEmpty
              inputProps={{
                style: {
                  paddingTop: 6,
                  paddingBottom: 6,
                  paddingLeft: 8,
                  paddingRight: 32,
                  overflow: "hidden",
                  textOverflow: "clip",
                },
              }}
              MenuProps={{ disableScrollLock: true }}
            >
            <MenuItem value="blocked">
              <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <BlockIcon fontSize="small" />
                Bloqueado
              </span>
            </MenuItem>
            <MenuItem value="registration">
              <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <Stop fontSize="small" />
                Permitir registro
              </span>
            </MenuItem>
            <MenuItem value="play">
              <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <PlayArrow fontSize="small" />
                Permitir juego
              </span>
            </MenuItem>
          </Select>
        </FormControl>
        </Tooltip>
        <Tooltip title="Edit">
          <Button
            style={buttonsStyle}
            size="small"
            onClick={() => history.push("/edit-game/" + cell._id)}
          >
            <EditIcon />
          </Button>
        </Tooltip>
        <Tooltip title="Play">
          <Button
            style={buttonsStyle}
            size="small"
            onClick={() => {
              navigator.clipboard.writeText(`${FRONT_URL}?game=${cell._id}`);
              setCopiedLink(true);
            }}
          >
            <IpadIcon />
          </Button>
        </Tooltip>
        <Tooltip title="Reset stats">
          <Button
            style={buttonsStyle}
            size="small"
            onClick={() => {
              setGameId(cell._id);
              setOpenConfirmDialog(3);
            }}
          >
            <Replay />
          </Button>
        </Tooltip>
        <Tooltip title="Delete">
          <Button
            style={buttonsStyle}
            size="small"
            onClick={() => {
              setGameId(cell._id);
              setOpenConfirmDialog(2);
            }}
          >
            <DeleteIcon />
          </Button>
        </Tooltip>
      </>
    );
  }

  function defaultFormatter(cell) {
    return cell ? (
      <div className="default-label badge badge-primary">default</div>
    ) : (
      ""
    );
  }

  function videoFormatter(cell) {
    const g = cell;
    const has = g?.hasIntroVideo === true;
    return (
      <Tooltip title={has ? "Con vídeo intro" : "Sin vídeo intro"}>
        <span style={{ display: "inline-flex", alignItems: "center", color: has ? "#1B3A94" : "#9e9e9e" }}>
          {has ? <VideocamOutlined fontSize="small" /> : <VideocamOffOutlined fontSize="small" />}
        </span>
      </Tooltip>
    );
  }

  const columns = [
    { dataField: "name", text: "Full name", sort: true },
    {
      dataField: "data",
      text: "Vídeo",
      formatter: videoFormatter,
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "64px",
        minWidth: "64px",
        maxWidth: "64px",
      },
      style: {
        width: "64px",
        minWidth: "64px",
        maxWidth: "64px",
        paddingLeft: "4px",
        paddingRight: "4px",
      },
    },
    { dataField: "default", text: "Default", formatter: defaultFormatter },
    {
      dataField: "data",
      text: "",
      formatter: buttonFormatter,
      align: "end",
    },
  ];

  useEffect(() => {
    getGames()
      .then((res) => {
        if (res.status === 200) {
          setData(getData(res.data));
          setRefresh(false);
        }
      })
      .catch((error) => {
        alertError({
          error: error,
          customMessage: "Could not get games.",
        });
      });
  }, [refresh]);

  return (
    <>
      <Card>
        <CardHeader title="Games list">
          <CardHeaderToolbar>
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => history.push("/edit-game")}
            >
              Add new
            </button>
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <Table data={data} columns={columns} />
          <ConfirmDialog
            title={"Are you sure you want to remove this game?"}
            open={openConfirmDialog === 2}
            setOpen={setOpenConfirmDialog}
            onConfirm={() => {
              deleteGame(gameId)
                .then((res) => {
                  if (res.status === 204) {
                    alertSuccess({
                      title: "Deleted!",
                      customMessage: "Game removed successfully.",
                    });
                    setRefresh(true);
                  }
                })
                .catch((error) => {
                  alertError({
                    error: error,
                    customMessage: "Could not remove game.",
                  });
                });
            }}
          />
          <ConfirmDialog
            title="Are you sure you want to set this game as default?"
            open={openConfirmDialog === 1}
            setOpen={setOpenConfirmDialog}
            onConfirm={() => {
              setDefaultGame(gameId)
                .then((res) => {
                  if (res.status === 200) {
                    alertSuccess({
                      title: "Success!",
                      customMessage: `Game activated`,
                    });
                    setRefresh(true);
                  }
                })
                .catch((error) => {
                  alertError({
                    error: error,
                    customMessage: "Game could not be activated.",
                  });
                });
            }}
          />
          <ConfirmDialog
            title="Are you sure you want to set reset all the data associated to this game?"
            open={openConfirmDialog === 3}
            setOpen={setOpenConfirmDialog}
            onConfirm={() => {
              resetGameStats(gameId)
                .then((res) => {
                  if (res.status === 204) {
                    alertSuccess({
                      title: "Success!",
                      customMessage: `Stats reset successfully`,
                    });
                    setRefresh(true);
                  }
                })
                .catch((error) => {
                  alertError({
                    error: error,
                    customMessage: "Could not reset stats.",
                  });
                });
            }}
          >
            {"This will erase all their groups and answers"}
          </ConfirmDialog>
        </CardBody>
      </Card>
      <Snackbar
        open={copiedLink}
        autoHideDuration={6000}
        onClose={() => setCopiedLink(false)}
      >
        <MuiAlert severity="info" sx={{ width: "100%" }}>
          Game link copied
        </MuiAlert>
      </Snackbar>
    </>
  );
}
